import { render, staticRenderFns } from "./GranissatHeadlineCanvas.vue?vue&type=template&id=05e3cbba&scoped=true&"
import script from "./GranissatHeadlineCanvas.vue?vue&type=script&lang=js&"
export * from "./GranissatHeadlineCanvas.vue?vue&type=script&lang=js&"
import style0 from "./GranissatHeadlineCanvas.vue?vue&type=style&index=0&id=05e3cbba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e3cbba",
  null
  
)

export default component.exports